var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-content',[_c('a-row',{attrs:{"slot":"content"},slot:"content"},[_c('product')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }